import Vue from 'vue';
import moment from 'moment';
import vueMoment from 'vue-moment';
import VueCurrencyFilter from 'vue-currency-filter';
import Vuelidate from 'vuelidate';
import VueHead from 'vue-head';
import { isIOS, isAndroid, isMobileOnly } from 'mobile-device-detect';

import { isBetaTest } from 'lib/system/env';

import capustaPrice from '@/plugins/capusta_price/index';
import capustaAlert from '@/plugins/capusta_alert/index';

import logrocket from 'services/logrocket';
import { initI18n } from 'services/i18n-setup';

import App from './App';
import router from './router';
import store from './store';
import filters from './services/filters';
import directives from './services/directives';

import layoutDirectives from '@/plugins/layoutDirectives';

// styles
import 'sass/variables.css';
import './styles/main.sass';

// eslint-disable-next-line no-unused-vars
import customPrototypes from '@/services/customPrototypes'; // добавляет протитопы при импорте

import FooterSection from '@/components/FooterSection';
import HeaderSection from '@/components/HeaderSection';

// inputs
import InputCardDate from '@/components/inputs/InputCardDate';
import InputCardPan from '@/components/inputs/InputCardPan';
import InputCVC from '@/components/inputs/InputCVC';
import InputEmail from '@/components/inputs/InputEmail';
import InputEmailPaid from '@/components/inputs/InputEmailPaid';
import InputPhone from '@/components/inputs/InputPhone';
import InputPrice from '@/components/inputs/InputPrice';
import InputText from '@/components/inputs/InputText';
import InputTextarea from '@/components/inputs/InputTextarea';
import AndroidBtnsManager from '@/components/inputs/AndroidBtnsManager';

import registerPlugins from '@/lib/plugins';
import components from './components/components';

// eslint-disable-next-line no-unused-expressions
import('moment/locale/ru');
layoutDirectives();

Vue.component('InputCardDate', InputCardDate);
Vue.component('InputCardPan', InputCardPan);
Vue.component('InputCVC', InputCVC);
Vue.component('InputEmail', InputEmail);
Vue.component('InputEmailPaid', InputEmailPaid);
Vue.component('InputPhone', InputPhone);
Vue.component('InputPrice', InputPrice);
Vue.component('InputText', InputText);
Vue.component('InputTextarea', InputTextarea);
Vue.component('AndroidBtnsManager', AndroidBtnsManager);

Vue.component('FooterSection', FooterSection);
Vue.component('HeaderSection', HeaderSection);

Object.keys(components).forEach(key => {
  Vue.component(key, components[key]);
});

registerPlugins(Vue);

Vue.config.productionTip = false;

moment.updateLocale('ru', {
  calendar: {
    lastDay: '[Вчера]',
    sameDay: '[Сегодня]',
    nextDay: '[Завтра]',
    lastWeek: 'DD.MM.YY',
    nextWeek: 'DD.MM.YY',
    sameElse: 'DD.MM.YY',
  },
});

Vue.prototype.$moment = vueMoment;
Vue.prototype.$openLink = function(link, blank = true, checkHttp = true) {
  if (checkHttp) {
    const isHttp = link.match(/^http[s]?:\/\//);
    const res = isHttp ? link : `//${link}`;
    window.open(res, blank ? '_blank' : '_self');
  } else window.open(link, blank ? '_blank' : '_self');
};

Vue.use(vueMoment, { moment });
Vue.use(VueCurrencyFilter, {
  symbol: '',
  // symbol: '₽',
  thousandsSeparator: ' ',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'back',
  symbolSpacing: true,
});
Vue.use(Vuelidate);
Vue.use(capustaPrice);
Vue.use(VueHead);
Vue.use(capustaAlert);

for (const filter of filters) {
  Vue.filter(filter.name, filter.func);
}

for (const directive of directives) {
  Vue.directive(directive.name, directive.directive);
}

if (isBetaTest()) {
  logrocket.init();
}

const applicationData = Promise.all([initI18n(), store.dispatch('GET_METADATA')]);

applicationData.then(data => {
  const [i18n] = data;

  new Vue({
    i18n,
    router,
    store,
    mounted() {
      store.commit('DEVICE_DETECT', { isIOS, isAndroid, isMobileOnly });
      store.commit('SET_WINDOW_SIZE', window.innerWidth);
      window.addEventListener('resize', () => store.commit('SET_WINDOW_SIZE', window.innerWidth));
    },
    beforeDestroy() {
      window.removeEventListener('resize', () => store.commit('SET_WINDOW_SIZE', window.innerWidth));
    },
    render: h => h(App),
  }).$mount('#app');
});
